"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitDatasetDistributorIndexing = void 0;
const routes_1 = require("../../routes");
const submitDatasetDistributorIndexing = (client) => async (distributorId, options = {}) => {
    const { prioritized = false, productIds } = options;
    const queryParams = new URLSearchParams();
    queryParams.append('prioritized', prioritized.toString());
    if (productIds) {
        const idsArray = Array.isArray(productIds) ? productIds : [productIds];
        idsArray.forEach((productId) => {
            queryParams.append('product_ids', productId);
        });
    }
    const url = `${routes_1.ENDPOINTS.SUBMIT_DATASET_PARTNER_INDEXING_TASK.applyParams(distributorId)}?${queryParams.toString()}`;
    await client.post(url, {});
};
exports.submitDatasetDistributorIndexing = submitDatasetDistributorIndexing;
